<template>
  <div>
    <v-row
      class="list-header d-flex align-center"
    >
      <v-col
        v-if="searchable"
        style="flex-grow:0;"
      >
        <search-list @search="handleSearch" />
      </v-col>
      <slot name="bulk-editor" />
      <v-col
        v-if="filterable"
        class="d-flex align-center"
      >
        <list-filter-menu
          :selected-filters="selectedFilters"
          :filters="filterOptions"
          @add-filter="handleFilter"
          @clear-filters="handleClearFilters"
        />
      </v-col>
      <v-spacer />
      <v-col
        class="d-flex align-center mt-2"
        style="flex-grow:0;"
      >
        <div
          v-if="paginationText"
          class="pr-6 top-pagination"
        >
          <span v-if="!paginationText.includes('undefined')">{{ paginationText }}</span>
          <v-skeleton-loader
            v-else
            loading
            type="chip"
          />
        </div>
        <div>
          <export-list
            v-if="exportable"
            @export-csv="handleExport"
          />
        </div>
        <div v-if="inMenu">
          <v-btn
            elevation="1"
            color="primary"
            @click="$emit('clear-org')"
          >
            <v-icon left>
              $faBackspace
            </v-icon>
            Clear Selected
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row class="list-header d-flex">
      <v-col>
        <template v-for="(slot, name) in $scopedSlots">
          <filter-menu
            v-if="selectedFilters.includes(unKebab(name))"
            :key="name"
            :label="unKebab(name)"
          >
            <slot :name="name" />
          </filter-menu>
        </template>
      </v-col>
    </v-row>
    <v-row>
      <slot name="number-selected" />
    </v-row>
  </div>
</template>
<script>
  import ExportList from '@/components/base/ExportList'
  import SearchList from '@/components/base/SearchList'
  import ListFilterMenu from './filters/ListFilterMenu.vue'
  import FilterMenu from './filters/FilterMenu.vue'

  export default {
    name: 'DefaultListHeader',
    components: { SearchList, ExportList, ListFilterMenu, FilterMenu },
    props: {
      listName: {
        type: String,
        default: '',
      },
      searchable: {
        type: Boolean,
        default: false,
      },
      exportable: {
        type: Boolean,
        default: false,
      },
      filterable: {
        type: Boolean,
        default: false,
      },
      inMenu: {
        type: Boolean,
        default: false,
      },
      paginationText: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      selectedFilters: [],
    }),
    computed: {
      filterOptions () {
        return Object.keys(this.$scopedSlots).map(slotName => this.unKebab(slotName))
      },
    },
    methods: {
      handleSearch (search) {
        this.$emit('search', search)
      },
      handleExport () {
        this.$emit('export-csv')
      },
      handleFilter (item) {
        this.selectedFilters.push(item)
      },
      handleClearFilters () {
        this.selectedFilters = []
        this.$emit('clear-filters')
      },
      unKebab (str) {
        return str.split('-').map(w => w[0].toUpperCase() + w.slice(1)).join(' ')
      },
    },
  }
</script>

<style lang="scss">
.top-pagination {
  letter-spacing: .5px;
  white-space: nowrap;
}
.v-skeleton-loader__chip {
  height: 10px !important;
}
</style>
